<template>
  <el-dialog
    class="messageDialogBox"
    :visible.sync="visible"
    width="384px"
    :append-to-body="true"
    :show-close="true"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :custom-class="'messageDialogContainer'"
    :destroy-on-close="true"
  >
    <div class="messageDialog">
      <div class="titleBox">
        <span class="title">
          <span name="title">{{ title }}</span>
        </span>
        <i class="el-icon-close closeIcon" @click="handleClose"></i>
      </div>
      <div class="content">
        {{ content }}
      </div>
      <div slot="footer" class="btnGroups" v-if="leftBtnTxt || rightBtnTxt">
        <button class="leftBtn btn" @click="handleClickLeftBtn" v-if="leftBtnTxt">
          {{ leftBtnTxt }}
        </button>
        <button class="rightBtn btn" @click="handleClickRightBtn" v-if="rightBtnTxt">
          {{ rightBtnTxt }}
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'MessageDialog',
  data() {
    return {
      visible: false,
      rightBtnTxt: '确定',
      leftBtnTxt: '取消',
      title: '温馨提示',
      content: '',
      onClose: () => {},
      onClickLeftBtn: () => {},
      onClickRightBtn: () => {}
    }
  },
  methods: {
    handleClose() {
      this.visible = false
      typeof this.onClose === 'function' && this.onClose()
      this.$destroy()
    },
    handleClickLeftBtn() {
      this.visible = false
      typeof this.onClickLeftBtn === 'function' && this.onClickLeftBtn()
      this.$destroy()
    },
    handleClickRightBtn() {
      this.visible = false
      typeof this.onClickRightBtn === 'function' && this.onClickRightBtn()
      this.$destroy()
    }
  }
}
</script>
<style scoped lang="less">
@import url('./main.less');
</style>
